import { useEffect, useState } from 'react';
import { copy } from '../copy';
import { formatClock } from '../lib/time';

interface StatusBarProps {
  online: boolean;
  queueCount: number;
}

/** Statusbalk: klok links, verbinding en wachtrij rechts. Rustig, geen badge die pulseert. */
export function StatusBar({ online, queueCount }: StatusBarProps) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 20_000);
    return () => window.clearInterval(timer);
  }, []);

  const showQueue = queueCount > 0;

  return (
    <div className="statusbar">
      <span>{formatClock(now)}</span>
      <span className="row" style={{ gap: 12 }}>
        <span className="statusbar__state">
          <span
            className={`statusbar__dot statusbar__dot--${online ? 'online' : 'offline'}`}
            aria-hidden
          />
          {online ? copy.status.online : copy.status.offline}
        </span>
        {showQueue ? (
          <span className="statusbar__state">
            <span className="statusbar__dot statusbar__dot--queue" aria-hidden />
            {copy.status.queue(queueCount)}
          </span>
        ) : null}
      </span>
    </div>
  );
}
